import { request, requestData } from '@/lib/api-client';
import type { LoginResult, MeResult, Session } from './types';

/**
 * Pharmacists and pharmacy staff sign in with email and password. Customers
 * authenticate with a one-time passcode and never reach this app; there is no
 * OTP path here on purpose.
 */
export function login(body: { email: string; password: string }): Promise<LoginResult> {
  return requestData<LoginResult>('/auth/login', { method: 'POST', body, anonymous: true });
}

export function me(): Promise<MeResult> {
  return requestData<MeResult>('/auth/me');
}

export function refresh(refreshToken: string): Promise<Session> {
  return requestData<Session>('/auth/refresh', {
    method: 'POST',
    body: { refreshToken },
    anonymous: true,
  });
}

export function logout(refreshToken: string): Promise<void> {
  return request<void>('/auth/logout', { method: 'POST', body: { refreshToken }, anonymous: true });
}

/** Revokes every session for this account — the answer to a counter tablet left unlocked. */
export function logoutEverywhere(): Promise<{ revokedSessions: number }> {
  return requestData<{ revokedSessions: number }>('/auth/logout-all', { method: 'POST' });
}
